import { useCallback, useRef } from 'react'
import { useSelector } from 'react-redux'
import { selectFeatureFlag, selectFeatureFlagsSettled } from '../features/featureFlags/selectors'

const usePinnedFeatureFlag = (key) => {
  const live = useSelector(selectFeatureFlag(key))
  const settled = useSelector(selectFeatureFlagsSettled)
  const pinned = useRef(null)

  if (pinned.current === null && settled) pinned.current = live

  const pin = useCallback(() => {
    if (pinned.current === null) pinned.current = false
  }, [])

  return { enabled: pinned.current === true, pin }
}

export default usePinnedFeatureFlag
